export default __webpack_public_path__ + "static/media/read-icon.9e08bc2a.svg";